import { getCompanyInfo } from "./getCompanyInfo";

/** 开启点击行为日志上报 */
export const isEnableClickLog = () => ['localhost', 'app.cartsee.com'].includes(window.location.hostname);

/** 开启新服务 */
export const isEnableNewService = () => true;

export const isEnableWheelCouponSetting = () => {
  return true;
}

export const isEnablePopupCover = () => {
  return true;
};

export const isEnablePrivacySetting = () => {
  return true;
}

export const isEnableCombinedDiscountCode = () => {
  return true;
}

export const isEnableAuth = () => {
  return [30, 328, 565, 1227, 1533, 2224, 2346, 2347, 2348, 2349, 2350, 2351, 907, 2523, 2733].includes(getCompanyInfo().id as number);
}